import axios from 'axios';
import { getAuthHeader } from './authService';

export interface Department {
  id: number;
  name: string;
  universityId?: number;
  createdAt?: string;
  updatedAt?: string;
}

class DepartmentService {
  private readonly API_URL = process.env.REACT_APP_API_BASE_URL || '/api';

  async getDepartments(): Promise<any> {
    try {
      const response = await axios.get(
        `${this.API_URL}/departments`,
        { headers: getAuthHeader() }
      );
      return response;
    } catch (error) {
      console.error('Error fetching departments:', error);
      throw error;
    }
  }

  async getDepartmentById(id: number): Promise<Department> {
    try {
      const response = await axios.get(
        `${this.API_URL}/departments/${id}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching department:', error);
      throw error;
    }
  }

  async createDepartment(department: Partial<Department>): Promise<Department> {
    try {
      const response = await axios.post(
        `${this.API_URL}/departments`,
        department,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating department:', error);
      throw error;
    }
  }

  async updateDepartment(id: number, department: Partial<Department>): Promise<Department> {
    try {
      const response = await axios.put(
        `${this.API_URL}/departments/${id}`,
        department,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating department:', error);
      throw error;
    }
  }

  async deleteDepartment(id: number): Promise<void> {
    try {
      await axios.delete(
        `${this.API_URL}/departments/${id}`,
        { headers: getAuthHeader() }
      );
    } catch (error) {
      console.error('Error deleting department:', error);
      throw error;
    }
  }
}

const departmentService = new DepartmentService();
export default departmentService;